// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape } from 'react-intl';
import classNames from 'classnames/bind';
import moment from 'moment/moment';
import { getLocalizedCountry } from '../../../local-values/utils/countries';
import { Link } from 'react-router-dom';

import style from './FlightBox.scss';
import icons from '../../../../assets/styles/icons.scss';

import type { Flight } from '../../../../entities';
import type { LocalValuesState } from '../../../local-values/duck';

type Props = {
  +flight: Flight;
  +localValues: LocalValuesState;
  +handleClickEdit?: (e: Event, flightId: string) => void;
  +handleClickDelete?: (e: Event, flightId: string) => void;
  +isPast?: boolean;
};

const DAY_LIMIT = 5;

export default class FlightBox extends Component<Props> {

  handleClickBox = (e: Event, outOfDate: boolean) => {
    if (outOfDate) return e.preventDefault();
  };

  render() {
    const { flight, localValues, handleClickEdit, handleClickDelete, isPast } = this.props;
    const momentDate = moment(flight.flightDate).utc();
    const diff = momentDate.diff(moment().startOf('day'), 'days');
    const outOfDate = 0 <= diff && diff < DAY_LIMIT && flight.orderCount === 0;
    const flightInfo =
      <section className={style.flightInfo}>
        <section className={style.locationWrap}>
          <section className={classNames(style.location, style.sides,
            style.left)}>
            {flight.departureAdmin1 && <p className={style.country}>
              {flight.departureAdmin1.name}
            </p>}
            <p>
              {getLocalizedCountry(flight.departureCountry.code, this.context.intl.formatMessage, localValues.countriesMap)}
            </p>
          </section>
          <section className={classNames(style.location, style.center)}>
            <p className={classNames(style.sides, style.left)}>...</p>
            <i className={icons.iconAirplaneMedium}/>
            <p className={classNames(style.sides, style.right)}>...</p>
          </section>
          <section className={classNames(style.location, style.sides,
            style.right)}>
            {flight.arrivalAdmin1 && <p className={style.country}>
              {flight.arrivalAdmin1.name}
            </p>}
            <p>
              {getLocalizedCountry(flight.arrivalCountry.code, this.context.intl.formatMessage, localValues.countriesMap)}
            </p>
          </section>
        </section>
        <FormattedMessage id="flights.active.flightDate">{
          txt => <p className={style.flightDate}>{txt}
            {moment(flight.flightDate).utc().format('DD MMM YYYY', { trim: false })}</p>
        }</FormattedMessage>
      </section>;
    const flightRightWrap =
      <section className={style.flightRightWrap}>
        <p className={style.count}>
          <i className={icons.iconShoppingCartMedium}/>
          {flight.orderCount || 0}
        </p>
        <hr/>
        <FormattedMessage id="flightBox.totalPayout">{
          txt => <p className={style.payment}>{txt}: $ {flight.travelerTotal}</p>
        }</FormattedMessage>
      </section>;
    return (
      <article className={classNames(style.itemWrap,
        { [style.outDated]: outOfDate },
        { [style.past]: isPast })}>
        {/*TODO: change 'to' to new module for flight's order only*/}
        <Link onClick={(e: Event) => this.handleClickBox(e, outOfDate)}
              className={style.default}
              to={flight.orderCount !== 0 ? `/flight/${flight.id}/sales` : `/flight/${flight.id}/requests`}>
          {flightInfo}
          {flightRightWrap}
          {handleClickEdit && handleClickDelete && flight.orderCount === 0 &&
          <section className={style.options}>
            <i className={classNames(icons.iconEditMedium, style.edit)}
               onClick={(e: Event) => handleClickEdit(e, flight.id)}/>
            <i className={classNames(icons.iconTrashcanMedium, style.delete)}
               onClick={(e: Event) => handleClickDelete(e, flight.id)}/>
          </section>}
        </Link>
        <Link onClick={(e: Event) => this.handleClickBox(e, outOfDate)}
              className={style.mobile}
              to={flight.orderCount !== 0 ? `/flight/${flight.id}/sales` : `/flight/${flight.id}/requests`}>
          <FormattedMessage id="flightBox.totalPayout">{
            txt => <p className={style.payment}>{txt}: $ {flight.travelerTotal}</p>
          }</FormattedMessage>
          <hr/>
          {flightInfo}
          <hr/>
          <p className={style.count}>
            <i className={icons.iconShoppingCartMedium}/>
            {flight.orderCount || 0}
          </p>
          {handleClickEdit && handleClickDelete && flight.orderCount === 0 &&
          <section className={style.options}>
            <i className={classNames(icons.iconTrashcanMedium, style.delete)}
               onClick={(e: Event) => handleClickDelete(e, flight.id)}/>
            <i className={classNames(icons.iconEditMedium, style.edit)}
               onClick={(e: Event) => handleClickEdit(e, flight.id)}/>
          </section>}
        </Link>
      </article>
    );
  }
}

FlightBox.propTypes = {
  flight: PropTypes.object.isRequired,
  localValues: PropTypes.object.isRequired,
  handleClickEdit: PropTypes.func,
  handleClickDelete: PropTypes.func,
  isPast: PropTypes.bool,
};

FlightBox.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/flights/components/FlightBox/FlightBox.jsx